import { Container } from 'inversify'
import { interpret } from 'xstate'
import { rootContainer } from '~/container'
import { userBookingsContainer } from '../user-bookings/inversify.config'
import { UserBookingsRepository } from '../user-bookings/repositories'
import { AddReviewRepositoryFetch } from './AddReviewRepositoryFetch'
import { GuestBookingRepositoryFetch } from './GuestBookingRepositoryFetch'
import { returnAddReviewStateMachine } from './machine'
import { AddReviewRepository, GuestBookingsRepository } from './repositories'

export const addReviewContainer = Container.merge(
  new Container(),
  userBookingsContainer,
)
addReviewContainer.parent = rootContainer
addReviewContainer.bind(GuestBookingsRepository).to(GuestBookingRepositoryFetch)
addReviewContainer.bind(AddReviewRepository).to(AddReviewRepositoryFetch)

export function getAddReviewMachine(langCode: string) {
  return interpret(
    returnAddReviewStateMachine().withConfig({
      services: {
        checkGuestCanAdd: async (ctx) => {
          if (!ctx.token) {
            throw new Error('token_required')
          }
          const response = await addReviewContainer
            .get(GuestBookingsRepository)
            .getByToken(ctx.token, langCode)
          return response.booking
            ? Promise.resolve(response)
            : Promise.reject(response)
        },
        getUserBookings: () =>
          addReviewContainer.get(UserBookingsRepository).readAll(langCode),
        submitReview: (ctx) => {
          const { campsiteSlug, token, reviewData } = ctx
          if (!reviewData) {
            throw new Error('review_data_required')
          }
          return addReviewContainer
            .get(AddReviewRepository)
            .create(campsiteSlug, reviewData, token || '', langCode)
        },
      },
    }),
  )
}
